import { Grid } from '@material-ui/core';
import React from 'react';
import { Option } from './Option';
import { useStyles } from './styles';

interface IListProps<TOption = unknown> {
  show: boolean;
  options: TOption[];
  option: (option: TOption, index: number) => JSX.Element;
}

function List<TOption extends { id: string | number }>({ show, option, options }: IListProps<TOption>) {
  const classes = useStyles();

  if (!show) {
    return null;
  }

  return (
    <Grid item xs={12} className={classes.container}>
      {!!options?.length && options?.map((opt, index) => option(opt, index))}

      {!options?.length && (
        <div className={classes.notFound}>
          <span>Nenhum produto encontrado</span>
        </div>
      )}
    </Grid>
  );
}

List.Option = Option;
export default List;
